/** Query parameter carrying the consent document id whose compiled bundle is read from `localStorage`. */
export const CONSENT_TEMPLATE_PREVIEW_QUERY_PARAM = 'consentPreview';
/**
 * URL for the preview route the host app should register (mount {@link ConsentTemplatePreviewPage} here).
 * @default `/consent-template-preview`
 */
export function getConsentTemplatePreviewUrl(documentId, options) {
    const pathname = options?.pathname ?? '/consent-template-preview';
    const url = new URL(pathname, window.location.origin);
    url.searchParams.set(CONSENT_TEMPLATE_PREVIEW_QUERY_PARAM, documentId);
    return url.toString();
}
/** Opens a new tab that should render {@link ConsentTemplatePreviewPage} for the given document id. */
export function openConsentTemplatePreviewInNewTab(documentId, options) {
    window.open(getConsentTemplatePreviewUrl(documentId, options), '_blank', 'noopener,noreferrer');
}
